module.exports = "/_next/static/images/our-story-7993f623db26cec8abfbeec0e7644a53.png";